<template lang="pug">
v-dialog(v-model="exportDialog" width="700" persistent)
    template(v-slot:activator="{ on, attrs }")
        v-btn.mr-5(small color="primary" dark v-bind="attrs" v-on="on")
            v-icon(small) mdi-download
    v-card
        v-card-title Export Data
        v-card-text
            v-checkbox(v-model="form.formPending" label="Export pending users" :disabled="dialogLoading")
            v-checkbox(v-model="form.formVerified" label="Export verified users" :disabled="dialogLoading")

        v-divider
        v-card-actions
            v-spacer
            v-btn(v-if="!dialogLoading" small color="red" text @click="exportDialog = false") Cancel
            v-btn(small color="primary" :disabled="submitDisabled" text @click="submit" :loading="dialogLoading") Download
</template>

<script>
import moment from 'moment';
import { mapActions } from 'vuex';
export default {
    data() {
        return {
            exportDialog: false,
            dialogLoading: false,
            submitDisabled: true,
            form: {
                formPending: false,
                formVerified: false
            }
        };
    },
    watch: {
        form: {
            handler(form) {
                if(form.formPending || form.formVerified) {
                    this.submitDisabled = false;
                } else {
                    this.submitDisabled = true;
                }
            },
            deep: true
        }
    },
    methods: {
        async submit() {
            this.dialogLoading = true;
            try {
                const result = await this.findReport({ query: {
                    $or: [
                        (this.form.formPending ? { status: 'PENDING' } : {}),
                        (this.form.formVerified ? { status: 'VERIFIED' } : {})
                    ],
                    $limit: -1
                }});
                const data = result.filter(item => !!item).map(item => {
                    return [item.id, `${item.fname} ${item.lname}`, item.email, item.status, moment(item.createdAt).format('lll')];
                });
                this.exportToCsv('generated-users-pending-report.csv', [
                    ['ID', 'Name', 'Email Address', 'Status', 'Date Created'],
                    ...data
                ]);
            } catch(err) {
                console.error(err);
            } finally {
                this.dialogLoading = false;
            }
        },
        exportToCsv(filename, rows) {
            var processRow = function (row) {
                var finalVal = '';
                for (var j = 0; j < row.length; j++) {
                    var innerValue = row[j] === null ? '' : row[j].toString();
                    if (row[j] instanceof Date) {
                        innerValue = row[j].toLocaleString();
                    };
                    var result = innerValue.replace(/"/g, '""');
                    if (result.search(/("|,|\n)/g) >= 0)
                        result = '"' + result + '"';
                    if (j > 0)
                        finalVal += ',';
                    finalVal += result;
                }
                return finalVal + '\n';
            };

            var csvFile = '';
            for (var i = 0; i < rows.length; i++) {
                csvFile += processRow(rows[i]);
            }

            var blob = new Blob([csvFile], { type: 'text/csv;charset=utf-8;' });
            if (navigator.msSaveBlob) { // IE 10+
                navigator.msSaveBlob(blob, filename);
            } else {
                var link = document.createElement("a");
                if (link.download !== undefined) { // feature detection
                    // Browsers that support HTML5 download attribute
                    var url = URL.createObjectURL(blob);
                    link.setAttribute("href", url);
                    link.setAttribute("download", filename);
                    link.style.visibility = 'hidden';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            }
        },
        ...mapActions('vw-user-verification', { findReport: 'find' }),
    }
};
</script>